// currently not being imported anywhere

export function isNumber(value: any): value is number {
  return !isNaN(value);
}

/**
 * @deprecated - Please use isNumber (isInteger now mimics functionality of isNumber)
 * @param value - any
 * @returns - boolean
 */
export function isInteger(value: any): boolean {
  return isNumber(value);
}

/**
 * @description - Generate an array of numbers
 * @param min - The lowest number in the range
 * @param max - The highest number in the range
 * @param step - The amount by which to increment each value
 * @returns - Array
 */
export function generateRange(min: number, max: number, step: number) {
  const arr = [];

  for (let i = min; i <= max; i += step) {
    arr.push(i);
  }

  return arr;
}
